






import { Component, Vue } from 'vue-property-decorator'
import authModule from '@/store/auth'

@Component({
  name: 'UserAvatar',
  components: {}
})
class UserAvatar extends Vue {
  private get user() {
    return authModule.user
  }
}
export default UserAvatar
